import { Container, Drawer, IconButton, Stack, Typography } from '@mui/material'
import { useState } from 'react'
import { NavLink } from 'react-router-dom'
import MenuIcon from '@mui/icons-material/Menu'
import CloseIcon from '@mui/icons-material/Close'

import { AppIcon } from '@/core/appIcon'
import { HEADER_NAV } from '@/constants'
import { scrollToSection } from '@/util'

import { HeaderBox } from './header.style'

export default function Header() {
  const [drawerOpen, setDrawerOpen] = useState<boolean>(false)

  const toggleDrawer = (open: boolean) => () => setDrawerOpen(open)

  const handleNavClick = (value: string) => {
    setDrawerOpen(false)
    scrollToSection(value)
  }

  return (
    <HeaderBox className='header'>
      <Container component={Stack} p={2} direction='row' alignItems='center' justifyContent='space-between'>
        <NavLink to='/' aria-label='Digital Coast home'>
          <AppIcon name='logo' width={100} height={52} ariaLabel='Digital Coast logo' />
        </NavLink>

        {/* Desktop nav — hidden below md */}
        <Stack
          component='nav'
          direction='row'
          spacing={3}
          alignItems='center'
          sx={{ display: { xs: 'none', md: 'flex' } }}
        >
          {HEADER_NAV.map(item => (
            <Typography
              key={item.value}
              component='button'
              onClick={() => handleNavClick(item.value)}
              aria-label={item.title}
              sx={{
                color: '#fff',
                cursor: 'pointer',
                transition: 'color 200ms ease',
                '&:hover': { color: 'secondary.main' },
                background: 'none',
                border: 0,
                padding: 0,
                font: 'inherit'
              }}
            >
              {item.title}
            </Typography>
          ))}
        </Stack>

        {/* Mobile hamburger — shown below md */}
        <IconButton
          onClick={toggleDrawer(true)}
          aria-label='Open navigation menu'
          sx={{ display: { xs: 'inline-flex', md: 'none' }, color: '#fff' }}
        >
          <MenuIcon />
        </IconButton>
      </Container>

      {/* Mobile drawer panel */}
      <Drawer
        anchor='right'
        open={drawerOpen}
        onClose={toggleDrawer(false)}
        PaperProps={{ sx: { backgroundColor: '#02040D', width: '78%', maxWidth: 320 } }}
        sx={{
          zIndex: 1000000
        }}
      >
        <Stack p={2} direction='row' alignItems='center' justifyContent='space-between'>
          <AppIcon name='logo' width={90} height={46} ariaLabel='Digital Coast logo' />
          <IconButton onClick={toggleDrawer(false)} aria-label='Close navigation menu' sx={{ color: '#fff' }}>
            <CloseIcon />
          </IconButton>
        </Stack>

        <Stack component='nav' p={2} spacing={0.5}>
          {HEADER_NAV.map(item => (
            <Typography
              key={item.value}
              component='button'
              onClick={() => handleNavClick(item.value)}
              aria-label={item.title}
              sx={{
                color: '#fff',
                cursor: 'pointer',
                px: 1.5,
                py: 1.5,
                borderRadius: 1,
                transition: 'all 200ms ease',
                '&:hover': { backgroundColor: 'rgba(73, 146, 255, 0.12)', color: 'secondary.main' },
                background: 'none',
                border: 0,
                padding: 0,
                textAlign: 'left'
              }}
            >
              {item.title}
            </Typography>
          ))}
        </Stack>
      </Drawer>
    </HeaderBox>
  )
}
